import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '@mitchell/react.component.ux';
const StyleDivBaseImage = `
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	width: 50px;
	height: 50px;
	outline: ${Magnetic.buttonFlatBorder};
	border-radius: 100%;
	border: ${Magnetic.buttonFlatBorder};
`;
export const StyleDivCloseUpImage = styled('img') `
	${StyleDivBaseImage}
`;
export const StyledDivCloseUpImageContainer = styled('div') `
	padding-bottom: ${Magnetic.spacer24};
	position: relative;
	overflow: auto;
	margin: ${Magnetic.spacer12} 0 ${Magnetic.spacer24} 0;
`;
export const StyledDivDefaultCloseUpImage = styled(Grid, {
    shouldForwardProp: prop => prop !== 'backgroundImage'
})((props) => `
	background: ${Magnetic[props.backgroundImage]} no-repeat center;
	height: 240px;
	width: 100%;
	margin-bottom:  ${Magnetic.spacer06};  
`);
export const StyledButtonContainer = styled('div') `
	position: absolute;
	display: flex;
	width: 100%;
	bottom: 0;
	justify-content: center;
`;
export const StyledDivButtonInnerContainer = styled('div') `
	width: 310px;
	display: flex;
	justify-content: space-between;
`;
export const StyledDivCloseUpImageButton = styled('button') `
    ${StyleDivBaseImage}	
	background-color: ${(props) => props.backgroundColor};
	color: ${Magnetic.colorWhite};
`;
//# sourceMappingURL=CloseUpShotComponent.style.js.map